function buildVariantsSwatches(containerClass) {
  if (!window.swatches) return;
  const swatchesArray = document.querySelectorAll(containerClass + ' .color-swatch');
  if (!swatchesArray) return
  // console.log(swatchesArray)
  swatchesArray.forEach(color => {
      const option = color.dataset.variantColor;
      if (!window.swatches[option]) return; 

      let optionColors = window.swatches[option] || {};
      let optionColor1 = optionColors.color1 || "";
      let optionColor2 = optionColors.color2 || "";
      let optionColor3 = optionColors.color3 || "";
      if (optionColor2 === "" || optionColor2 === "rgba(0,0,0,0)") {
          color.setAttribute("id", "one-color");
      }
      if (optionColor3 != "" || optionColor3 === "rgba(0,0,0,0)") {
          color.setAttribute("id", "three-colors");
      }
      color.querySelector('.swatch').children[0].style.backgroundColor = optionColor1;
      // color.querySelector('.swatch').children[1].style.backgroundColor = optionColor2;
      // color.querySelector('.swatch').children[2].style.backgroundColor = optionColor3;
  });
  const swatchesContainerArray = document.querySelectorAll(containerClass + ' .variant-container');
  swatchesContainerArray.forEach(el => {
    if(el.childElementCount > 0){
      el.style.display = 'flex';
    }
  })
}
function initVariants(containerClass) {
  document.querySelectorAll(containerClass + ' .color-swatch').forEach(elem => {
      elem.addEventListener('click', function (e) {
        const variantAvailable = this.getAttribute('data-variant-available');
        if (variantAvailable === 'false' || variantAvailable === 'undefined') {
          e.preventDefault();
          return;
        }
        if(this.getAttribute('data-variant-src') === 'undefined') return;
        this.closest('.variant-result').querySelector('img').src = this.getAttribute('data-variant-src');
        if (!this.classList.contains('active')) {
          Array.from(this.parentElement.children).forEach(item => item.classList.remove('active'));
          this.classList.add('active');
        }
      })
  })
}
